<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 800" class="fixed left-0 top-0 min-h-screen min-w-screen"
    preserveAspectRatio="none">
    <rect [attr.fill]="dark ? 'var(--primary-900)' : 'var(--primary-500)'" width="1600" height="800" />
    <path [attr.fill]="dark ? 'var(--primary-800)' : 'var(--primary-400)'"
        d="M478.4 581c3.2 0.8 6.4 1.7 9.5 2.5c196.2 52.5 388.7 133.5 593.5 176.6c174.2 36.6 349.5 29.2 518.6-10.2V0H0v574.9c52.3-17.6 106.5-27.7 161.1-30.9C268.4 537.4 375.7 554.2 478.4 581z" />
    <path [attr.fill]="dark ? 'var(--primary-700)' : 'var(--primary-300)'"
        d="M181.8 259.4c98.2 6 191.9 35.2 281.3 72.1c2.8 1.1 5.5 2.3 8.3 3.4c171 71.6 342.7 158.5 531.3 207.7c198.8 51.8 403.4 40.8 597.3-14.8V0H0v283.2C59 263.6 120.6 255.7 181.8 259.4z" />
    <path [attr.fill]="dark ? 'var(--primary-600)' : 'var(--primary-200)'"
        d="M454.9 86.3C600.7 177 751.6 269.3 924.1 325c208.6 67.4 431.3 60.8 637.9-5.3c12.8-4.1 25.4-8.4 38.1-12.9V0H288.1c56 21.3 108.7 50.6 159.7 82C450.2 83.4 452.5 84.9 454.9 86.3z" />
    <path [attr.fill]="dark ? 'var(--primary-500)' : 'var(--primary-100)'"
        d="M1397.5 154.8c47.2-10.6 93.6-25.3 138.6-43.8c21.7-8.9 43-18.8 63.9-29.5V0H643.4c62.9 41.7 129.7 78.2 202.1 107.4C1020.4 178.1 1214.2 196.1 1397.5 154.8z" />
</svg>
<ng-container *ngIf="!isAndroidBrowser; else telaPromo">
    <div class="px-5 min-h-screen flex justify-content-center align-items-center">
        <div class="border-1 surface-border surface-card border-round py-7 px-5 z-1"
            style="border-radius: 15px !important;">
            <div class="mb-4">
                <div class="flex align-items-center justify-content-center gap-2">
                    <img [src]="logoSrc" alt="Logo" style="height: 40px;" />
                    <div class="text-900 text-xl font-bold">Cadastrar</div>
                </div>
            </div>
            <div class="flex flex-column">
                <div class=" mb-4">
                    <span class="p-input-icon-left w-full">
                        <i class="pi pi-user"></i>
                        <input id="username" type="text" pInputText class="w-full md:w-25rem"
                            placeholder="Nome completo" [(ngModel)]="name" (keypress)="filterSpecialCharsNames($event)"
                            (ngModelChange)="validateName()" (blur)="validateName()" />

                    </span>
                    <div class="flex align-items-center justify-content-between mt-2" *ngIf="errorName">
                        <span class="p-error">O nome não pode estar vazio</span>
                    </div>
                </div>
                <div class=" mb-4">
                    <span class="p-input-icon-left w-full">
                        <i class="pi pi-home"></i>
                        <input id="email" type="text" pInputText class="w-full md:w-25rem" placeholder="Nome da Loja"
                            [(ngModel)]="store_name" (keypress)="filterSpecialCharsNames($event)"
                            (ngModelChange)="validateStoreName()" (blur)="validateStoreName()">

                    </span>
                    <div class="flex align-items-center justify-content-between mt-2" *ngIf="errorStoreName">
                        <!-- Mensagem de Erro à esquerda -->
                        <span class="p-error" [ngStyle]="{
                        visibility: errorStoreName ? 'visible' : 'hidden'
                      }">
                            O nome da loja não pode estar vazio
                        </span>
                    </div>
                </div>
                <div class="mb-4">
                    <span class="p-input-icon-left w-full ">
                        <i class="pi pi-envelope"></i>
                        <input id="email" type="text" pInputText class="w-full md:w-25rem" placeholder="Email"
                            [(ngModel)]="new_email" (ngModelChange)="checkEmail(); checkEmailValid();">
                    </span>
                    <div class="flex flex-column mt-2" *ngIf="errorDisponibilidadeEmal || errorEmail">
                        <span class="p-error">
                            {{
                            errorDisponibilidadeEmal
                            ? 'Já existe usuário com o username informado.'
                            : 'Insira um email válido'
                            }}
                        </span>
                    </div>

                </div>
                <div class="mb-4">
                    <span class="p-input-icon-left w-full ">
                        <i class="pi pi-lock z-2"></i>
                        <p-password id="password" placeholder="Password" [(ngModel)]="password"
                            (ngModelChange)="checkPassword()" styleClass="w-full" [inputStyle]="{paddingLeft: '2.5rem'}"
                            inputStyleClass="w-full md:w-25rem" [toggleMask]="true" [feedback]="false"></p-password>
                    </span>
                    <div class="flex align-items-center justify-content-between mt-2" *ngIf="errorPassword">
                        <!-- Mensagem de Erro à esquerda -->
                        <span class="p-error" [ngStyle]="{
                        visibility: errorPassword ? 'visible' : 'hidden'
                      }">
                            A senha deve ter pelo menos 6 caracteres
                        </span>
                    </div>
                </div>
                <button pButton pRipple label="Criar Conta" (click)="criarConta()" [loading]="criarLoagind"
                    class="w-full mb-4"></button>
                <span class="font-medium text-600">Já tem uma conta2? <a
                        class="font-semibold cursor-pointer text-900 hover:text-primary transition-colors transition-duration-300"
                        [routerLink]="['/auth/login']">Login</a></span>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #telaPromo>
    <style>
        body {
            min-height: 100vh;
            margin: 0;
        }

        .promo-wrapper {
            position: relative;
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .promo-content {
            width: 100%;
            max-width: 50vw;
            background: white;
            border-radius: 1rem;
            box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
            overflow: hidden;
            display: flex;
            flex-wrap: wrap;
        }

        .promo-left {
            padding: 1.5rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .promo-right {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
        }

        .video-wrapper {
            position: relative;
            height: 100%;
            max-width: 100%;
            aspect-ratio: 9 / 16;
            /* max-height: 70vh; */
        }

        .video-wrapper video {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 0.5rem;
        }

        .play-button {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 3rem;
            background: rgba(0, 0, 0, 0.4);
            color: white;
            border-radius: 50%;
            width: 60px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            /* pointer-events: none; */
        }

        .play-button.hidden {
            opacity: 0;
            pointer-events: none;
        }

        .qr-e-botoes {
            margin-top: 2rem;
            display: flex;
            gap: 1rem;
            align-items: center;
        }

        .lojas img {

            margin: 0.5rem 0;
            display: block;
        }

        /* Grid system */
        .col-12 {
            width: 100%;
        }

        .md\:col-8 {
            width: 66.6667%;
        }

        .md\:col-4 {
            width: 33.3333%;
        }

        @media (min-width: 769px) {
            .promo-left {
                height: 100%;
            }

            .promo-left p {
                margin-bottom: 2rem;
                text-align: justify;
            }

            .qr-e-botoes {
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 2rem;
                width: 100%;
            }

            .qr-e-botoes img,
            .qr-e-botoes .lojas {
                flex: 1 1 0;
            }

            .qr-e-botoes img {
                max-width: 50%;
            }

            .qr-e-botoes .lojas {
                max-width: 120px;
            }

            .lojas {
                display: flex;
                align-items: center;
            }

            .lojas {
                flex-direction: column;
            }

            .lojas img {
                /* height: 40px; */
                max-width: 100%;
            }
        }

        /* Responsivo */
        @media (max-width: 768px) {

            .md\:col-8,
            .md\:col-4 {
                width: 100%;
            }

            .hide-on-mobile {
                display: none;
            }

            .promo-content {
                flex-direction: column;
                align-items: center;
                padding: 1rem;
                max-width: 70vw;
            }

            .promo-left {
                padding: 1rem;
                text-align: left;
            }

            .promo-left h2 {
                text-align: center;
            }

            .promo-left p {
                text-align: justify;
            }

            .qr-e-botoes {
                flex-direction: column;
                align-items: center;
                gap: 1rem;
                margin-top: 0rem;
                width: 100%;
            }

            .lojas {
                width: 100%;
            }

            .lojas img {
                width: 100%;
                margin: 0;
            }

            .promo-right {
                display: none !important;
            }
        }
    </style>

    <!-- -->

    <div class="promo-wrapper z-1">
        <div class="promo-content grid">

            <!-- Texto (col-9) -->
            <div class="promo-left md:col-8 col-12">
                <h2>BAIXE NOSSO <br />
                    <div class="text-5xl font-bold">NOVO APP</div>
                </h2>
                <p>
                    Baixando e instalando nosso novo aplicativo você poderá gerenciar todas suas mídias e
                    widgets interativos direto do seu smartphone.
                </p>
                <div class="qr-e-botoes">
                    <img src="assets/qrcode.svg" class="hide-on-mobile" alt="QR Code" />
                    <div class="lojas">
                        <img src="assets/Google_Play_Store_badge_EN.svg" alt="Google Play" />
                    </div>
                </div>
            </div>

            <!-- Vídeo (col-3) -->
            <div class="promo-right col-12 md:col-4 hide-on-mobile">
                <div class="video-wrapper  cursor-pointer" (click)="togglePromoVideo()">
                    <video muted loop playsinline #promoVideo
                        src="https://d2434dp583bttd.cloudfront.net/public/media/041326fe-7d98-4dd9-b505-73af23f54c6a/36d80a7a-d888-4391-947b-597fa2a27f23.mp4"></video>
                    <div class="play-button" [class.hidden]="isPlaying">
                        ▶
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- -->

</ng-template>
<app-config [minimal]="true"></app-config>